<template>
  <div class="spinner-wrap">
      <div class="spinner">
          <i v-for="n in nodes" :key="n.angle" :style="n"></i>
      </div>
  </div>
</template>

<script>
export default {
    name: "spinner",
    data: function () {
        return {
            show: false,
            nodes: []
        }
    },
    mounted: function(){
        const nodecnt = 14, adelta=360/nodecnt,odelta=1/nodecnt;
        this.nodes = Array.from(Array(nodecnt),(n,i)=>({transform:'rotate('+(i*adelta)+'deg)', opacity:(i*odelta).toFixed(2)}));
    }
}
</script>

<style>
.spinner-wrap {
    text-align: center;
}
.spinner {
    height: 100px;
    width: 100px;
    display: inline-block;
    position: relative;
    animation: spin 1s steps(14, end) infinite;
}
.spinner>i {
    height: 30px;
    width: 6px;
    margin-left: -3px;
    display: block;
    transition: height 1s;
    position: absolute;
    left: 50%;
    transform-origin: center 50px;
    background: #808080;
    box-shadow: 0 0 3px rgba(128,128,128, .7);
    border-radius: 3px;
    animation: pulse 2s ease-in-out alternate-reverse infinite;
}
@keyframes spin {
	from { transform: rotate(0deg); }
	to { transform: rotate(360deg); }
}
@keyframes pulse {
	from { height:6px; }
    50% {height: 10px}
	to { height:14px; }
}
</style>